// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f671d85b","453":"8faa970c","455":"44440379"}[chunkId] + ".chunk.js";
};